const formatValidatedValues = ({ item, price, isAvailable }) => ({
  ...item,
  price: { ...item.price, current: price },
  isAvailable,
  validated: true,
});

export { formatValidatedValues };
